'use strict'

const promisify = require('promisify-es6')

module.exports = (send) => {
  return promisify((callback) => {
    send({
      path: 'bitswap/wantlist'
    }, callback)
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/bitswap/wantlist.js
// module id = 312
// module chunks = 0